import React from 'react';

const IconArrowRight = () => (
  <svg width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 7.5H23.5" fill="none" stroke="currentColor"/>
    <path d="M17 1L23.5 7.5L17 14" fill="none" stroke="currentColor"/>
  </svg>
);

export default IconArrowRight;
